import { Button, Card, Grid, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  useLazyGetConversionRateQuery,
  useSetConversionRateMutation,
} from "../../services/settings";
import { errorToast, successToast } from "../../helpers";
import { isNumber } from "../../utils/validation";
import useTranslation from "../../hooks/Translation";

const ExchangeRate = () => {
  const t = useTranslation();
  const [setRateApi] = useSetConversionRateMutation();
  const [getRate] = useLazyGetConversionRateQuery();
  const [loading, setLoading] = useState(false);
  const [rate, setRate] = useState("");
  const [error, setError] = useState(false);

  const getConversionRate = async () => {
    setLoading(true);
    try {
      const response = await getRate({}).unwrap();
      if (response?.status === 200) {
        setRate(response?.data);
        setLoading(false);
      }
    } catch (error: any) {
      setLoading(false);
      console.log(error, "errror");
      errorToast(error?.data?.message || "");
    }
  };

  const setConversionRate = async () => {
    if (!rate) {
      setError(true);
      return;
    } else {
      setError(false);
    }

    const body = {
      conversion_rate: Number(rate),
    };
    setLoading(true);
    try {
      const response = await setRateApi(body).unwrap();
      if (response?.status === 200) {
        setRate(response?.data);
        setLoading(false);
        successToast(t.main.conversionUpdated);
      }
    } catch (error: any) {
      setLoading(false);
      console.log(error, "errror");
      errorToast(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getConversionRate();
  }, []);

  return (
    <div>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{t.main.conversionRate}</h1>
        </div>
        <Card className="cards">
          <Grid container spacing={2}>
            <Grid item lg={4} md={4} sm={4} xs={12}>
              <Typography className="custom_label">
                {t.main.conversionUsdToAed}
              </Typography>
              <TextField
                className="text_field"
                hiddenLabel
                type={"text"}
                variant="outlined"
                fullWidth
                placeholder={t.main.conversionUsdToAed}
                inputProps={{ maxLength: 5 }}
                value={rate}
                onChange={(e) => {
                  let value = e.target.value;
                  if (/^\d*\.?\d{0,2}$/.test(value)) {
                    setRate(value);
                  }
                }}
                helperText={error && !rate ? t.error.required : ""}
              />
            </Grid>
            <div className="form_btn" style={{ marginLeft: "18px" }}>
              <Button
                size="large"
                onClick={setConversionRate}
                className="btn btn_primary"
              >
                {t.main.save}
              </Button>
            </div>
          </Grid>
        </Card>
      </div>
    </div>
  );
};

export default ExchangeRate;
